export default __webpack_public_path__ + "i18n/zh-CN.1e56877188612e6cafe90f2cc1bce9d7.json";